import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [],
  template: `
    <div class="flex items-center gap-2">
      <div [class]="'w-2 h-2 rounded-full ' + dotClass"></div>
      <span class="text-xs capitalize font-medium" [class]="textClass">
        {{ label }}
      </span>
    </div>
  `,
})
export class StatusBadgeComponent {
  @Input({ required: true }) isActive!: boolean;

  get dotClass(): string {
    return this.isActive
      ? 'bg-light-success dark:bg-dark-success animate-pulse-subtle'
      : 'bg-light-text-tertiary dark:bg-dark-text-tertiary';
  }

  get textClass(): string {
    return this.isActive
      ? 'text-light-success dark:text-dark-success'
      : 'text-light-text-tertiary dark:text-dark-text-tertiary';
  }

  get label(): string {
    return this.isActive ? 'activo' : 'inactivo';
  }
}
